import { render } from "./ImportDetailInformationTab.vue?vue&type=template&id=70ae09ca&scoped=true"
import script from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"
export * from "./ImportDetailInformationTab.vue?vue&type=script&lang=js"

import "./ImportDetailInformationTab.vue?vue&type=style&index=0&id=70ae09ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ae09ca"]])

export default __exports__